import { Close } from '@material-ui/icons';
import { use100vh } from 'react-div-100vh';

import { createStyles, makeStyles } from '@material-ui/styles';
import themes from 'styles/themes';
import { STRINGS } from '../../constants/strings';
import homeScreenImg from '../../assets/img/home_screen.png';
import { useHistory } from 'react-router-dom';
import { PATH } from 'routes/constant';
import { CREATE_PROFILE_POPUP_OPENED_ACTION } from '.';

export const useStyles = makeStyles(() =>
    createStyles({
        popupTitleIcon: {
            color: themes.palette.primary.main,
        },
        caption: {
            fontFamily: 'Poppins',
            fontSize: '12px',
            fontWeight: 400,
            textAlign: 'center',
        },
        headerText: {
            fontFamily: 'Poppins',
            fontSize: '20px',
            fontWeight: 600,
            textAlign: 'center',
        },
        btn: {
            marginTop: '10px',
            padding: '12px',
            borderRadius: '29px',
        },
        createProfileBtn: {
            background: '#1A1A1A',
        },
        btnText: {
            fontFamily: 'Poppins',
            fontSize: '14px',
            fontWeight: 500,
            textAlign: 'center',
            textTransform: 'uppercase',
        },
        createProfileTxt: {
            color: '#FFFFFF',
        },
        flexColumn: {
            display: 'flex',
            flexDirection: 'column',
        },
        bgImg: {
            backgroundImage: `url(${homeScreenImg})`,
            backgroundPosition: 'center bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
            height: '100%',
            width: 'auto',
        },
        flex1: {
            flex: 1,
        },
        p10: {
            padding: '10px',
        },
        py24: {
            padding: '24px 0px',
        },
        mt10: {
            marginTop: '10px',
        },
        dflex: {
            display: 'flex',
        },
        justifyContentEnd: {
            justifyContent: 'flex-end',
        },
        justifyContentCenter: {
            justifyContent: 'center',
        },
    }),
);

export default function CreateProfile(props) {
    const classes = useStyles();
    const height: any = use100vh();
    const { handleClose, createProfilePromptTitle } = props;
    const history = useHistory();
    const handleNavigation = (action) => {
        handleClose(true, action);
        switch (action) {
        case CREATE_PROFILE_POPUP_OPENED_ACTION.CREATE_PROFILE:
            history.push(PATH.SIGNUP_CUSTOMER);
            break;
        case CREATE_PROFILE_POPUP_OPENED_ACTION.ALREADY_HAVE_A_PROFILE:
            history.push(PATH.LOGIN);
            break;
        default:
            break;
        }
    };

    return (
        <div
            className={`${classes.flexColumn} ${classes.flex1}`}
            style={{
                height: `calc(${height}px - 109px)`,
            }}
        >
            <div className={`${classes.dflex} ${classes.justifyContentEnd}`}>
                <div
                    className={classes.p10}
                    onClick={() => handleClose(false, CREATE_PROFILE_POPUP_OPENED_ACTION.CLOSED)}
                >
                    <Close className={classes.popupTitleIcon} />
                </div>
            </div>
            <div className={`${classes.flexColumn} ${classes.flex1} ${classes.p10}`}>
                <div className={classes.flexColumn}>
                    <div className={classes.headerText}>{createProfilePromptTitle}</div>
                    <div className={classes.caption}>{STRINGS.PLEASE_CREATE_PROFILE}</div>
                </div>
                <div
                    className={`${classes.flexColumn} ${classes.flex1} ${classes.justifyContentCenter} ${classes.py24}`}
                >
                    <div className={classes.bgImg} />
                    <div className={`${classes.caption} ${classes.mt10}`}>{STRINGS.HYPER_PERSONALIZED_MESSAGE}</div>
                </div>
                <div className={classes.flexColumn}>
                    <div
                        className={`${classes.btn} ${classes.createProfileBtn} ${classes.btnText} ${classes.createProfileTxt}`}
                        onClick={() => handleNavigation(CREATE_PROFILE_POPUP_OPENED_ACTION.CREATE_PROFILE)}
                    >
                        {STRINGS.CREATE_PROFILE}
                    </div>
                    <div
                        className={`${classes.btn} ${classes.btnText}`}
                        onClick={() => handleNavigation(CREATE_PROFILE_POPUP_OPENED_ACTION.ALREADY_HAVE_A_PROFILE)}
                    >
                        {STRINGS.ALREADY_HAVE_A_PROFILE}
                    </div>
                </div>
            </div>
        </div>
    );
}
